import apiClient from './client'

export interface UserPreferences {
  user_id: string
  current_assistant_id?: string | null
  ui_settings: Record<string, any>
}

export interface UpdatePreferencesRequest {
  current_assistant_id?: string | null
  ui_settings?: Record<string, any>
}

export interface UpdateCurrentAssistantRequest {
  current_assistant_id: string | null
}

/**
 * Get user preferences from server
 */
export async function getUserPreferences(userId: string): Promise<UserPreferences> {
  const { data } = await apiClient.get<UserPreferences>(`/users/${userId}/preferences`)
  return data
}

/**
 * Update all user preferences
 */
export async function updateUserPreferences(
  userId: string,
  preferences: UpdatePreferencesRequest
): Promise<void> {
  await apiClient.put(`/users/${userId}/preferences`, preferences)
}

/**
 * Update only current assistant ID
 */
export async function updateCurrentAssistant(
  userId: string,
  assistantId: string | null
): Promise<void> {
  await apiClient.put(`/users/${userId}/preferences/current-assistant`, {
    current_assistant_id: assistantId,
  })
}
